import { Box, Card, Button, Typography, IconButton } from '@mui/material'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import { useState } from 'react'
import CommonModal from '../../atoms/modal/CommonModal'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import TextArea from '../../atoms/textarea/TextArea'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../../features/authSlice'

export const BusinessDesCard = ({ formData, cardStyle, editable }) => {
    const dispatch = useDispatch()
	const [businessDescription, setBusinessDescription] = useState('')
	const [open, setOpen] = useState(false)
	const newDescription =
		formData?.businessDescription || ''
	const handleClose = () => {
		setOpen(false)
	}
	const handleOpen = () => {
		setOpen(true)
		setBusinessDescription(newDescription)
	}
	const handleSave = () => {
        dispatch(
            updateProfile({
                businessDescription: businessDescription?.trim() || '',
            })
        )
		setOpen(false)
	}

	return (
		<>
			<Card
				sx={cardStyle}
				variant="outlined"
				className={styles.vendorCardBusinessDecInfo}
			>
				<div className={styles.infoHeader}>
					<Typography
						variant="h5"
						gutterBottom
						sx={{ fontWeight: 'bold' }}
					>
						Business Description
					</Typography>
					{editable && (
						<IconButton
							component="label"
							className={styles.editIcon}
							disableRipple
							onClick={handleOpen}
						>
							<img
								src="/images/edit-icon.svg"
								alt="business pic"
							/>
						</IconButton>
					)}
				</div>
				<Box className={styles.infoContent}>
					<div className={styles.businessDetail}>
						<Typography gutterBottom variant="h5">
							{newDescription}
						</Typography>
					</div>
				</Box>
			</Card>

			<CommonModal
				open={open}
				handleClose={handleClose}
				heading="Edit Business Description"
				footerContent={
					<>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleSave}
						>
							Save
						</ButtonCustom>
					</>
				}
			>
				<div>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							gap: '1rem',
						}}
					>
						<TextArea
							value={businessDescription}
							onChange={(e) =>
								setBusinessDescription(e.target.value)
							}
						/>
					</Box>
				</div>
			</CommonModal>
		</>
	)
}
